module.exports = __webpack_public_path__ + "img/description.2a1f749d.svg";